// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"37":"1baa9729","40":"3c8d66ac","511":"7a029422","515":"b19b87c8","537":"35929916","658":"1b091a3d"}[chunkId] + ".chunk.js";
};